import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var Cocktail2Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21.29 4.185c.3-.38.47-.86.47-1.35 0-1.2-.98-2.18-2.18-2.18H4.42c-1.2 0-2.18.98-2.18 2.18 0 .49.17.97.47 1.35l1.62 2.06 6.66 8.48v6.62H7.21c-.55 0-1 .45-1 1s.45 1 1 1h9.55c.55 0 1-.45 1-1s-.45-1-1-1h-3.78v-6.61l8.31-10.55zM4.28 2.955s-.04-.07-.04-.11c0-.1.08-.18.18-.18h15.15c.1 0 .18.08.18.18 0 .04-.01.08-.04.11l-1.32 1.68H5.6l-1.32-1.69v.01zm12.54 3.69L12 12.785l-4.82-6.14h9.65-.01z"
                    })
                })
            })
        ]
    });
};
Cocktail2Icon.isCarinaIcon = true;
export default Cocktail2Icon;
